import { combineReducers } from '@reduxjs/toolkit';
import { auth_slice } from './modules/auth';

const rootReducer = combineReducers({
  auth: auth_slice.reducer
});

export default rootReducer;


